import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import FooterLogo from "../assets/images/FooterLogo.png";

export const FooterLogoSec = () => {
    return (
        <div className="FooterLogo">
            <img src={FooterLogo} alt="FooterLogo" />
            <div className="button-with-arrow">
                <Link to="#">
                    <button className="hover-effect">hello@EpicTexasCharters <FontAwesomeIcon icon={faArrowRight} /> </button>
                </Link>
            </div>
        </div>
    );
};
